// @ts-nocheck
import { getTypeDef, TypeDefInfo, unwrapStorageType } from '@polkadot/types';
import { getSiName } from '@polkadot/types/metadata/util';
import { isNull } from '@polkadot/util';

export default function createOptions(api, sectionName) {
  if (!api) {
    return;
  }
  const section = api.query[sectionName];

  if (!section || Object.keys(section).length === 0) {
    return [];
  }

  return Object.keys(section)
    .sort()
    .map(value => {
      const {
        meta: { docs, modifier, name, type },
      } = section[value];
      const output = unwrapStorageType(api.registry, type, modifier.isOptional);
      let input = '';

      if (type.isMap) {
        const { hashers, key } = type.asMap;

        if (hashers.length === 1) {
          input = getSiName(api.registry.lookup, key);
        } else {
          const si = api.registry.lookup.getSiType(key).def;

          if (si.isTuple) {
            input = si.asTuple
              .map(t => getSiName(api.registry.lookup, t))
              .join(', ');
          } else {
            input = si.asHistoricMetaCompat.toString();
          }
        }
      }

      return {
        className: 'ui--DropdownLinked-Item',
        key: `${sectionName}_${value}`,
        text: [
          <div
            className="ui--DropdownLinked-Item-call"
            key={`${sectionName}_${value}:call`}
          >
            {value}({input}): {output}
          </div>,
          <div
            className="ui--DropdownLinked-Item-text"
            key={`${sectionName}_${value}:text`}
          >
            {(docs[0] || name).toString()}
          </div>,
        ],
        value,
      };
    });
}

export function queryTypeToString(
  registry,
  {
    creator: {
      meta: { modifier, type },
    },
  },
) {
  //console.log('achbasdj', type);
  const _type = unwrapStorageType(registry, type);

  return modifier.isOptional ? `Option<${_type}>` : _type;
}

function checkIterable(registry, type) {
  // in the case of Option<type> keys, we don't allow map iteration, in this case
  // we would have option for the iterable and then option for the key value
  if (type.isPlain) {
    return true;
  }

  const { hashers, key } = type.asMap;

  if (hashers.length === 1) {
    return registry.lookup.getTypeDef(key).info !== TypeDefInfo.Option;
  }

  const keys = registry.lookup.getSiType(key).def.asTuple;

  return (
    registry.lookup.getTypeDef(keys[keys.length - 1]).info !==
    TypeDefInfo.Option
  );
}

export function extractParams(isIterable, values) {
  const params = values.filter(
    ({ value }, index) =>
      !isIterable || index !== values.length - 1 || !isNull(value),
  );

  return [params, params.length === values.length];
}

export function expandParams(registry, st, isIterable) {
  let types = [];

  if (st.isMap) {
    const { hashers, key } = st.asMap;

    types =
      hashers.length === 1
        ? [getSiName(registry.lookup, key)]
        : registry.lookup
            .getSiType(key)
            .def.asTuple.map(k => getSiName(registry.lookup, k));
  }

  return types.map((str, index) => {
    let type;

    if (isIterable && index === types.length - 1) {
      type = getTypeDef(`Option<${str}>`);
      type.withOptionActive = true;
    } else {
      type = getTypeDef(str);
    }

    return { type };
  });
}

export function expandKey(api, key) {
  const {
    creator: {
      meta: { type },
      section,
    },
  } = key;
  const isIterable = checkIterable(api.registry, type);

  return {
    defaultValues:
      section === 'session' &&
      type.isMap &&
      api.consts.session &&
      api.consts.session.dedupKeyPrefix
        ? [{ isValid: true, value: api.consts.session.dedupKeyPrefix.toHex() }]
        : null,
    isIterable,
    key,
    params: expandParams(api.registry, type, isIterable),
  };
}
